import { useState } from 'react';
import { useNavigate } from "react-router-dom";

import { GetStatus } from 'services/exchanges/getStatus';
import { handleValidadeError, isVehicleTypeMismatchMessage, vehicleTypeMismatchMessage } from 'utils/parseErrosQuotation';
import { PostCancelChange } from 'services/exchanges/postCancelChange';
import { GetListarCotacoes } from 'services/exchanges/getListarCotacoes';
import { PostQuotePlatform } from 'services/exchanges/postQuotePlatform';
import { PostValidateChoose } from 'services/exchanges/postValidateChoose';
import { PostQuoteListservices } from 'services/exchanges/postQuoteListservices';
import { PostChooseQuoteItems } from 'services/shoppingCart/postChooseQuoteItems';
import { PostCreateChangeSolicitation } from 'services/exchanges/postCreateChangeSolicitation';
import { PostCancelChangeOwnerSolicitation } from 'services/exchanges/postCancelChangeOwnerSolicitation';
import { GetChangeSolicitation } from 'services/exchanges/getChangeSolicitation';
import { PostObterDadosCorretorPorPedido } from 'services/exchanges/postObterDadosCorretorPorPedido';
import { PostCreateChangeSolicitationPlatform } from 'services/exchanges/postCreateChangeSolicitationPlatform';
import { getBrands, getColors, getModels, getVersions, getYear } from 'services/exchanges/getSearchCarDetails';

import { FormDataPerfil, ParamsBodyPostQuoteListservices, ParamsDataPostQuoteListservices, ParamsBodyPostCreateChangeSolicitation, handleBodyFormDataPerfil, ParamsBodyValidateChoose, ParamsBodyCart, ParamsDataValidateChoose, ParamsDataGetListarCotacoes, ParamsBodyPostGetStatus, ParamsBodyPostQuotePlatform, ParamsBodyCreateChangeSolicitationPlatform, ParamsBodyPostObterDadosCorretorPorPedido, ParamsDataPostObterDadosCorretorPorPedido, ParamsDataGetStatus, ParamsBodyChooseQuoteItems, ParamsBodyPostCancelChange, ParamsPayloadCartDetails, ParamsDataCar, ParamsVersion, NR_COMPARACAO_TROCA, ParamsBodyChangeSolicitation } from 'utils/typeServices';

const useExchanges = () => {
    const navigate = useNavigate();
    const [isFormCar, setIsFormCar] = useState<boolean | Array<ParamsVersion>>();
    const [dataCar, setDataCar] = useState<ParamsDataCar>();
    const [formDataPerfil, setFormDataPerfil] = useState<FormDataPerfil>();
    const [dataCreateChangeSolicitation, setDataCreateChangeSolicitation] = useState<{ cD_SOLICITACAO: number; success?: boolean; } | false>();
    const [dataGetChangeSolicitation, setDataGetChangeSolicitation] = useState<any | false>();
    const [dataQuoteListservices, setDataQuoteListservices] = useState<ParamsDataPostQuoteListservices | false>();
    const [dataValidateChoose, setDataValidateChoose] = useState<ParamsDataValidateChoose>();
    const [dataListarCotacoes, setDataListarCotacoes] = useState<Array<ParamsDataGetListarCotacoes> | false>();
    const [sucessChangeSolicitationPlatform, setSucessChangeSolicitationPlatform] = useState<boolean>();
    const [dataObterDadosCorretorPorPedido, setDataObterDadosCorretorPorPedido] = useState<ParamsDataPostObterDadosCorretorPorPedido | false>();
    const [dataGetListarCotacoes, setDataGetListarCotacoes] = useState<ParamsDataGetStatus>();
    const [dataPostCancelChange, setDataPostCancelChange] = useState<boolean>();
    const [dataPostCancelChangeOwnerSolicitation, setDataPostCancelChangeOwnerSolicitation] = useState<boolean>();
    const [dataErrorTicketOpen, setDataErrorTicketOpen] = useState<boolean>();
    const [dataVehicleTypeMismatch, setDataVehicleTypeMismatch] = useState<string>();

    const handleClearExchanges = () => {
        setIsFormCar(undefined);
        setFormDataPerfil(undefined);
        setDataPostCancelChange(undefined);
        setDataPostCancelChangeOwnerSolicitation(undefined);
        setDataCreateChangeSolicitation(undefined);
        setDataGetChangeSolicitation(undefined);
        setDataQuoteListservices(undefined);
        setDataValidateChoose(undefined);
        setDataListarCotacoes(undefined);
        setDataGetListarCotacoes(undefined);
        setSucessChangeSolicitationPlatform(undefined);
        setDataObterDadosCorretorPorPedido(undefined);
        setDataErrorTicketOpen(undefined);
        setDataVehicleTypeMismatch(undefined);
    }

    const handleClearDataValidateChoose = () => setDataValidateChoose(undefined);

    const handleClearVehicleTypeMismatch = () => setDataVehicleTypeMismatch(undefined);

    const handleFormDataPerfil = ({ body, sameProfile = false, linkNavigate }: handleBodyFormDataPerfil) => {
        setFormDataPerfil(body);
        navigate(linkNavigate, { state: { sameProfile: sameProfile } });
    }

    const handlePostQuoteListservices = async ({ body, isWebView }: { body: ParamsBodyPostQuoteListservices, isWebView: boolean }) => {
        setDataQuoteListservices(undefined);
        setDataVehicleTypeMismatch(undefined);
        const data = await PostQuoteListservices({ body });

        if (data && typeof data !== 'string') {
            setDataQuoteListservices(data);
            navigate(`${isWebView ? 'wb/' : ''}central-de-trocas/troca-de-servico/planos`);
        } else {
            setDataQuoteListservices(false);

            if (typeof data === 'string' && isVehicleTypeMismatchMessage(data)) {
                setDataVehicleTypeMismatch(vehicleTypeMismatchMessage);
            }
        }
    }

    const handlePostValidateChoose = async ({ body, bodyCart, isWebView }: { body: ParamsBodyValidateChoose, bodyCart: ParamsBodyCart, isWebView: boolean }) => {
        setDataValidateChoose(undefined);
        const data = await PostValidateChoose({ body });

        if (data) {
            setDataValidateChoose(data);
            if (data.success && data.data?.nR_COMPARACAO_TROCA !== NR_COMPARACAO_TROCA.Incompativel) {
                navigate(`${isWebView ? 'wb/' : ''}central-de-trocas/troca-de-servico/servicos-adicionais`);
            }
        } else {
            setDataValidateChoose({
                data: null,
                errorCode: 'default_error',
                message: '',
                success: false
            });
        }
    }

    const handleErrorTicketOpen = async (showError: boolean) => {
        setDataErrorTicketOpen(showError);
    }

    const handleGetChangeSolicitation = async ({ body }: { body: ParamsBodyChangeSolicitation }) => {
        setDataGetChangeSolicitation(undefined);
        const data = await GetChangeSolicitation({ body: body });

        if (data && data.success) {
            setDataGetChangeSolicitation(data);
        } else {
            setDataGetChangeSolicitation(false);
        }
    }

    const handlePostCreateChangeSolicitation = async ({ body }: { body: ParamsBodyPostCreateChangeSolicitation }) => {
        setDataCreateChangeSolicitation(undefined);
        const data = await PostCreateChangeSolicitation({ body });

        if (data?.success) {
            setDataCreateChangeSolicitation({ ...data?.data, success: true });
        } else {
            setDataCreateChangeSolicitation(false);
        }
    }

    const handleGetListarCotacoes = async (CPF_CNPJ: string) => {
        setDataListarCotacoes(undefined);
        const data = await GetListarCotacoes(CPF_CNPJ);

        if (data && data?.length > 0) {
            setDataListarCotacoes(data);
        } else {
            setDataListarCotacoes(false);
        }
    }
    const handlePostGetStatus = async ({ body, isWebView }: { body: ParamsBodyPostGetStatus, isWebView: boolean }) : Promise<ParamsDataGetStatus | null> => {
        setDataGetListarCotacoes(undefined);
        const data = await GetStatus(body.GUID_COTACAO);
        if (data?.success) {
            setDataGetListarCotacoes(data.data);
            setDataQuoteListservices(data.data.quote);
            if(data?.data){
                setDataValidateChoose({
                    errorCode: null,
                    success: true,
                    message: "Teste",
                    data:{
                        nR_TIPO_PRODUTO: data.data.quoteItemsChooses?.find(x => x?.nR_TIPO_PRODUTO === 11 || x?.nR_TIPO_PRODUTO === 12)?.nR_TIPO_PRODUTO ?? null,
                        fL_AGENDAMENTO: data.data.fL_AGENDAMENTO,
                        nR_COMPARACAO_TROCA: data.data.nR_COMPARACAO_TROCA
                    }
                });
            }

            switch (data.data.cotacaoPedidoStatus) {
                case 1:
                    navigate(`${isWebView ? 'wb/' : ''}central-de-trocas/${data.data.quote.nR_TIPO_COTACAO === 3 ? 'troca-de-servico' : 'troca-de-veiculo'}/planos`);
                    return data?.data;
                case 2:
                    navigate(`${isWebView ? 'wb/' : ''}central-de-trocas/troca-de-servico/servicos-adicionais`, { state: { isExchangesInProgress: true, cD_PEDIDO: data.data.cD_PEDIDO } });
                    return data?.data;
                case 3:
                    if(data.data.fL_AGENDAMENTO){
                        navigate(`${isWebView ? 'wb/' : ''}central-de-trocas/troca-de-servico/agendamento`, { state: { isExchangesInProgress: true, cD_PEDIDO: data.data.cD_PEDIDO_NOVO } });
                    }else{
                        navigate(`${isWebView ? 'wb/' : ''}central-de-trocas`, { state: { isExchangesInProgress: true, cD_PEDIDO: data.data.cD_PEDIDO_NOVO } });
                    }
                    return data?.data;
                case 4:
                    navigate(`${isWebView ? 'wb/' : ''}central-de-trocas/troca-de-servico/resumo-pedido`, { state: { isExchangesInProgress: true, cD_PEDIDO: data.data.cD_PEDIDO_NOVO } });
                    return data?.data;
                default:
                    return null;
            }
        }else{
            return null
        }
    }
    const handlePostQuotePlatform = async ({ body, isWebView }: { body: ParamsBodyPostQuotePlatform, isWebView: boolean }) => {
        setIsFormCar(undefined);
        setDataQuoteListservices(undefined);
        setDataVehicleTypeMismatch(undefined);
        const data = await PostQuotePlatform({ body: body });

        if (data && typeof data !== 'string') {
            setDataQuoteListservices(data);
            navigate(`${isWebView ? 'wb/' : ''}central-de-trocas/troca-de-veiculo/planos`);
        } else {
            setDataQuoteListservices(false);

            if (typeof data === 'string' && isVehicleTypeMismatchMessage(data)) {
                setDataVehicleTypeMismatch(vehicleTypeMismatchMessage);
            } else if (typeof data === 'string' && handleValidadeError(data)) {
                setIsFormCar(true);
                handleSearchCar({ typeDetailsCar: 'brands', codDetailCar: 0 });
            } else if (typeof data === 'string' && data.includes('NR_MODELO_FIPE')) {
                if (JSON.parse(data)?.find(({ DS_COR }: { DS_COR: string }) => !DS_COR)) {
                    handleSearchCar({ typeDetailsCar: 'brands', codDetailCar: 0 });
                }
                const listVersions = JSON.parse(`[${data.split('[')[1]}`);
                setIsFormCar(listVersions);
            }
        }
    }

    const handlePostCreateChangeSolicitationPlatform = async ({ body, bodyChooseQuoteItems }: { body: ParamsBodyCreateChangeSolicitationPlatform, bodyChooseQuoteItems: ParamsBodyChooseQuoteItems }) => {
        setSucessChangeSolicitationPlatform(undefined);
        const dataQuoteItems = await PostChooseQuoteItems({
            body: {
                cD_COTACAO: bodyChooseQuoteItems.cD_COTACAO,
                cD_PEDIDO: bodyChooseQuoteItems.cD_PEDIDO,
                customerId: bodyChooseQuoteItems.customerId,
                quoteItemsChoose: bodyChooseQuoteItems.quoteItemsChoose
            }
        });

        if (dataQuoteItems) {
            const data = await PostCreateChangeSolicitationPlatform({ body: body });

            if (data?.success) {
                setSucessChangeSolicitationPlatform(true);
            } else {
                setSucessChangeSolicitationPlatform(false);
            }
        } else {
            setSucessChangeSolicitationPlatform(false);
        }
    }

    const handlePostObterDadosCorretorPorPedido = async (body: ParamsBodyPostObterDadosCorretorPorPedido) => {
        setDataObterDadosCorretorPorPedido(undefined);
        const data = await PostObterDadosCorretorPorPedido({ body: body });

        if (data) {
            setDataObterDadosCorretorPorPedido(data);
        } else {
            setDataObterDadosCorretorPorPedido(false);
        }
    }

    const handlePostCancelChange = async (body: ParamsBodyPostCancelChange) => {
        setDataPostCancelChange(undefined);
        const data = await PostCancelChange({ body: body });

        if (data) {
            setDataPostCancelChange(true);
        } else {
            setDataPostCancelChange(false);
        }
    }

    const handlePostCancelChangeOwnerSolicitation = async (body: ParamsBodyChangeSolicitation) => {
        setDataPostCancelChangeOwnerSolicitation(undefined);
        const data = await PostCancelChangeOwnerSolicitation({ body: body });

        if (data) {
            setDataPostCancelChangeOwnerSolicitation(true);
        } else {
            setDataPostCancelChangeOwnerSolicitation(false);
        }
    }

    const handleSearchCar = async ({ typeDetailsCar, codDetailCar }: ParamsPayloadCartDetails) => {
        switch (typeDetailsCar) {
            case 'brands':
                const { DtBrands } = await getBrands(localStorage.getItem('token')!);
                const { DtColors } = await getColors(localStorage.getItem('token')!);

                if (DtBrands && DtColors) {
                    setDataCar({ ...dataCar, brands: DtBrands, colors: DtColors });
                }

                return;

            case 'models':
                const { DtModels } = await getModels(codDetailCar, localStorage.getItem('token')!);

                if (DtModels) {
                    setDataCar({ ...dataCar, models: DtModels });
                }
                return;

            case 'versions':
                const { DtVersions } = await getVersions(codDetailCar, localStorage.getItem('token')!);

                if (DtVersions) {
                    setDataCar({ ...dataCar, versions: DtVersions });
                }
                return;

            case 'year':
                const { DtYear } = await getYear(codDetailCar, localStorage.getItem('token')!);

                if (DtYear) {
                    setDataCar({ ...dataCar, year: DtYear });
                }
                return;
        }
    }

    return { formDataPerfil, dataQuoteListservices, dataCreateChangeSolicitation, dataGetChangeSolicitation, dataValidateChoose, dataListarCotacoes, sucessChangeSolicitationPlatform, dataObterDadosCorretorPorPedido, dataGetListarCotacoes, dataPostCancelChange, dataPostCancelChangeOwnerSolicitation, dataErrorTicketOpen, dataCar, isFormCar, dataVehicleTypeMismatch, handleFormDataPerfil, handlePostQuoteListservices, handlePostCreateChangeSolicitation, handleGetChangeSolicitation, handlePostValidateChoose, handleGetListarCotacoes, handlePostGetStatus, handlePostQuotePlatform, handlePostCreateChangeSolicitationPlatform, handlePostObterDadosCorretorPorPedido, handleClearExchanges, handleClearDataValidateChoose, handleClearVehicleTypeMismatch, handlePostCancelChange, handlePostCancelChangeOwnerSolicitation, handleErrorTicketOpen, handleSearchCar };
}

export default useExchanges;
